import store from '@/store';
import { notify } from '@/shared/utils/browser-notify';
export default class AgentVoiceLoginEvent {
  constructor(body) {
    if (body.voice) {
      if (store.state.attendance.Attendance.useWebRTC === 'Y') {
        if (
          store.state.channel.latestVoiceStatusBeforeDisconnect.status ==
            'paused' ||
          store.state.channel.latestVoiceStatusBeforeDisconnect.status ==
            'scheduled_pause'
        ) {
          const id = store.state.attendance.Attendance.agentId;
          const description =
            store.state.channel.latestVoiceStatusBeforeDisconnect.status ==
            'paused'
              ? store.state.channel.latestVoiceStatusBeforeDisconnect
                  .description
              : 'Reconexão';
          const informations = {
            pause: description,
            whatsapp: false,
            voice: true,
          };
          store.dispatch('pause/pauseAgentChannelVoice', { id, informations });

          const notification = {
            title: 'Conexão de voz restaurada',
            body: 'O canal de voz foi reconectado com sucesso e você está em pausa novamente',
            phoneNumber: '',
          };
          notify(notification, true, 'voiceWebrtcReconnectionSuccess');
        } else {
          if (
            store.state.channel.latestVoiceStatusBeforeDisconnect.status ==
            'available'
          ) {
            const notification = {
              title: 'Conexão de voz restaurada',
              body: 'O canal de voz foi reconectado com sucesso e você está disponível para novas chamadas.',
              phoneNumber: '',
            };

            notify(notification, true, 'voiceWebrtcReconnectionSuccess');
          }

          if (
            store.state.attendance.Attendance.agentLoginStartsPaused.voice ===
              true &&
            store.state.channel.latestVoiceStatusBeforeDisconnect.status != ''
          ) {
            store.dispatch('pause/unpauseAgentChannelVoice', {
              agentId: store.state.attendance.Attendance.agentId,
            });
          } else {
            store.dispatch('channel/setLatestStatusBeforeDisconnect', true);
          }

          store.dispatch('channel/setConnectedInVoice');
        }
      } else {
        store.dispatch('channel/setConnectedInVoice');
      }
    } else {
      store.dispatch('showSnackbar', {
        text: 'errorConnectChannel',
        type: 'error',
      });
    }
  }
}
